import { __extends } from "tslib";
import { axCoerceString, ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var TextSnapshot = /** @class */ (function (_super) {
    __extends(TextSnapshot, _super);
    function TextSnapshot() {
        return _super.call(this) || this;
    }
    Object.defineProperty(TextSnapshot.prototype, "charCount", {
        // _charCount: number /*int*/;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextSnapshot', 'get charCount', '');
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    TextSnapshot.prototype.findText = function (beginIndex /*int*/, textToFind, caseSensitive) {
        beginIndex = beginIndex | 0;
        textToFind = axCoerceString(textToFind);
        caseSensitive = !!caseSensitive;
        // @todo
        Debug.throwPIR('playerglobals/text/TextSnapshot', 'findText', '');
        return 0;
    };
    TextSnapshot.prototype.getSelected = function (beginIndex /*int*/, endIndex /*int*/) {
        beginIndex = beginIndex | 0;
        endIndex = endIndex | 0;
        // @todo
        Debug.throwPIR('playerglobals/text/TextSnapshot', 'getSelected', '');
        return false;
    };
    TextSnapshot.prototype.getSelectedText = function (includeLineEndings) {
        if (includeLineEndings === void 0) { includeLineEndings = false; }
        includeLineEndings = !!includeLineEndings;
        // @todo
        Debug.throwPIR('playerglobals/text/TextSnapshot', 'getSelectedText', '');
        return '';
    };
    TextSnapshot.prototype.getText = function (beginIndex /*int*/, endIndex /*int*/, includeLineEndings) {
        if (includeLineEndings === void 0) { includeLineEndings = false; }
        beginIndex = beginIndex | 0;
        endIndex = endIndex | 0;
        includeLineEndings = !!includeLineEndings;
        // @todo
        Debug.throwPIR('playerglobals/text/TextSnapshot', 'getText', '');
        return '';
    };
    TextSnapshot.prototype.getTextRunInfo = function (beginIndex /*int*/, endIndex /*int*/) {
        beginIndex = beginIndex | 0;
        endIndex = endIndex | 0;
        // @todo
        Debug.throwPIR('playerglobals/text/TextSnapshot', 'getTextRunInfo', '');
        return null;
    };
    TextSnapshot.prototype.hitTestTextNearPos = function (x, y, maxDistance) {
        if (maxDistance === void 0) { maxDistance = 0; }
        x = +x;
        y = +y;
        maxDistance = +maxDistance;
        // @todo
        Debug.throwPIR('playerglobals/text/TextSnapshot', 'hitTestTextNearPos', '');
        return 0;
    };
    TextSnapshot.prototype.setSelectColor = function (hexColor) {
        if (hexColor === void 0) { hexColor = 16776960; }
        hexColor = hexColor >>> 0;
        // @todo
        Debug.throwPIR('playerglobals/text/TextSnapshot', 'setSelectColor', '');
    };
    TextSnapshot.prototype.setSelected = function (beginIndex /*int*/, endIndex /*int*/, select) {
        beginIndex = beginIndex | 0;
        endIndex = endIndex | 0;
        select = !!select;
        // @todo
        Debug.throwPIR('playerglobals/text/TextSnapshot', 'setSelected', '');
    };
    // Called whenever the class is initialized.
    TextSnapshot.classInitializer = null;
    return TextSnapshot;
}(ASObject));
export { TextSnapshot };
